export const publishersColumns = [{
  dataField: 'name',
  text: 'Publisher Name',
  sortable: true,
  sortBy: 'name',
}, {
  dataField: 'total_apps_count',
  text: 'Total # of Apps',
  sortable: true,
  sortBy: 'total_apps_count',
}, {
  dataField: 'downloads_rank',
  text: 'Download Rank',
  sortable: true,
  sortBy: 'downloads_rank',
}, {
  dataField: 'total_revenue_rank',
  text: 'Revenue Rank',
  sortable: true,
  sortBy: 'total_revenue_rank',
},{
  dataField: 'mau_rank',
  text: 'Usage Rank',
  sortable: true,
  sortBy: 'mau_rank',
}, {
  dataField: 'total_downloads_rank',
  text: 'Total Downloads',
  sortable: true,
}, {
  dataField: 'revenue_rank',
  text: 'Total Revenue',
  sortable: true,
},{
  dataField: 'mau',
  text: 'MAU',
  sortable: true,
}];
